module.exports = require('./helpers/bundle-url').getBundleURL('dwYZa') + "flash.5ac9a66c.png";